import React, { useState, useEffect } from "react";
import { LanguageProvider } from "./LanguageProvider";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import ContactPage from "./pages/ContactPage";
import CaseStudiesPage from "./pages/CaseStudiesPage";
import RumboPage from "./pages/RumboPage";
import InsightsPage from "./pages/InsightsPage";
import AboutPage from "./pages/AboutPage";
import SecurityPage from "./pages/SecurityPage";
import footerData from "./i18n/footer.json";


// Valid routes
const VALID_ROUTES = ["home", "services", "cases", "contact", "rumbo", "insights", "about", "security"];

// Aliases — soportar URLs viejas
const ROUTE_ALIASES = { forecasting: "rumbo", "planificacion-optima": "rumbo", "reposicion-optima": "rumbo", "reposicion-inteligente": "rumbo", seguridad: "security" };

// Read route from URL hash
function getRouteFromHash() {
  let hash = window.location.hash.replace("#/", "").replace("#", "");
  if (ROUTE_ALIASES[hash]) hash = ROUTE_ALIASES[hash];
  return VALID_ROUTES.includes(hash) ? hash : "home";
}


export default function App() {
  const [route, setRoute] = useState(getRouteFromHash);
  const [language, setLanguage] = useState("es");


  // Listen for browser back/forward
  useEffect(() => {
    const handleHashChange = () => {
      setRoute(getRouteFromHash());
      window.scrollTo({ top: 0, behavior: "auto" });
    };
    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);


  const onNavigate = (r) => {
    // Home is the bare domain: no "#/home" in the URL.
    if (r === "home") window.history.pushState(null, "", window.location.pathname + window.location.search);
    else window.location.hash = `#/${r}`;
    setRoute(r);
    window.scrollTo({ top: 0, behavior: "auto" });
  };


  const onLanguageChange = (lang) => setLanguage(lang);


  return (
    <LanguageProvider>
      <div className="min-h-screen bg-white">
        <Nav
          current={route}
          onNavigate={onNavigate}
          language={language}
          onLanguageChange={onLanguageChange}
        />


        {route === "home" && <HomePage onNavigate={onNavigate} language={language} />}
        {route === "services" && <ServicesPage onNavigate={onNavigate} language={language} />}
        {route === "cases" && <CaseStudiesPage language={language} onNavigate={onNavigate} />}
        {route === "rumbo" && <RumboPage onNavigate={onNavigate} language={language} />}
        {route === "insights" && <InsightsPage language={language} />}
        {route === "about" && <AboutPage onNavigate={onNavigate} language={language} />}
        {route === "contact" && <ContactPage onNavigate={onNavigate} language={language} />}
        {route === "security" && <SecurityPage language={language} />}


        <Footer onNavigate={onNavigate} t={footerData[language]} />
      </div>
    </LanguageProvider>
  );
}



